import AboutHero from "./components/AboutHero"
import About1 from "./components/About1"
import { Newsletter } from "../components"

export default function AboutUs() {
  return (
    <>
      <section>
        <AboutHero />
        <About1 />
        <Newsletter />
      </section>
    </>
  )
}
